import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { StaticDataTypeLabel, StaticDataTypeLabelDetail, StaticDataTypeLabelParams } from './staticDataTypeLabel.types';

export const getStaticDataTypeLabelList = (client: AxiosInstance) => async (params: StaticDataTypeLabelParams) => {
  return (
    await client.get<PaginatedApiResponse<StaticDataTypeLabel[]>>(API_ROUTES.GET_STATIC_DATA_TYPE_LABEL, { params })
  ).data;
};

const getStaticDataTypeLabelDetail = (client: AxiosInstance) => async (staticDataLabelId: string) =>
  (
    await client.get<ApiResponse<StaticDataTypeLabelDetail>>(API_ROUTES.GET_STATIC_DATA_TYPE_LABEL_DETAIL, {
      params: { staticDataLabelId },
    })
  ).data;

export const staticDataTypeLabelQueries = {
  all: () => ['static-data-type-label'],
  list: (params: StaticDataTypeLabelParams) =>
    queryFactoryOptions<PaginatedApiResponse<StaticDataTypeLabel[]>>({
      queryKey: [...staticDataTypeLabelQueries.all(), 'list', params],
      queryFn: (client) => () => getStaticDataTypeLabelList(client)(params),
    }),
  details: (staticDataLabelId: string) =>
    queryFactoryOptions<ApiResponse<StaticDataTypeLabelDetail>>({
      queryKey: [...staticDataTypeLabelQueries.all(), 'details', staticDataLabelId],
      queryFn: (client) => () => getStaticDataTypeLabelDetail(client)(staticDataLabelId),
    }),
};
